export default __webpack_public_path__ + "static/media/cost.bc67a897.svg";